import React from "react";
// This component's own .popup/.popupModal/.data_message styling (centering, sizing, the token-URL
// wrap fix) lives in these two shared files - imported directly here rather than relying on
// ReleaseNotes.tsx happening to import them elsewhere (an incidental dependency this component
// had no control over and no import of its own to guarantee).
import "../../../../../assets/styles/component/documentation.scss";
import "../../../../../assets/styles/component/releaseNotes.scss";

export const TokenDialog = (props: { open: boolean; onCloseClick: () => void; link: string }) => {
  const { open, onCloseClick, link } = props;
  return (
    <div className={`popup release_popup ${open ? "show" : ""}`}>
      <div className="popupModal ">
        <button className="closePopup" onClick={onCloseClick}>
          ╳
        </button>

        <div className="data_message">{link}</div>
      </div>
    </div>
  );
};
